module.exports = __webpack_public_path__ + "media/images/company-logos/verband-logo-14ce1c010dc30c9c85fcb08434f6f2fa.jpg";